// extracted by mini-css-extract-plugin
export default {"wrapper":"BundlePageLabels_wrapper","label":"BundlePageLabels_label"};